import { useSelector } from 'react-redux';

import { selectMeteorologyAgroWBSequentialDVTriggerRequest } from 'redux/reducers/meteorologyAgroWBSequentialDVReducer';
import useGroup from 'hooks/Meteorology/Agro/WaterBalanceSequential/DetailedView/useGroup';
import useLocation from 'hooks/Meteorology/Agro/WaterBalanceSequential/DetailedView/useLocation';
import usePeriod from 'hooks/Meteorology/Agro/WaterBalanceSequential/DetailedView/usePeriod';
import useSoil from 'hooks/Meteorology/Agro/WaterBalanceSequential/DetailedView/useSoil';
import useChartVariable from 'hooks/Meteorology/Agro/WaterBalanceSequential/DetailedView/useChartVariable';
import useGraphData from 'hooks/Meteorology/Agro/WaterBalanceSequential/DetailedView/useGraphData';
import useParams from 'hooks/Meteorology/Agro/WaterBalanceSequential/DetailedView/useParams';
import useClearControlPanel from 'hooks/Meteorology/Agro/WaterBalanceSequential/DetailedView/useClearControlPanel';

export default function useDetailedViewMobile() {
  const group = useGroup();
  const location = useLocation();
  const period = usePeriod();
  const soil = useSoil();
  const chartVariable = useChartVariable();
  const params = useParams();
  const {
    graphData, runDate, isFetching: graphDataLoading, queryError, onRetry,
  } = useGraphData();
  const clearControlPanel = useClearControlPanel();
  const triggerRequest = useSelector(selectMeteorologyAgroWBSequentialDVTriggerRequest);

  return {
    group,
    location,
    period,
    soil,
    chartVariable,
    params,
    graphData,
    runDate,
    graphDataLoading,
    queryError,
    onRetry,
    clearControlPanel,
    triggerRequest,
  };
}
